module.exports = __webpack_public_path__ + "img/wordpress.6419541e.svg";